import { OptionsObject, SnackbarKey, useSnackbar, ProviderContext } from 'notistack';
import React from 'react';
import { CANCEL_MESSAGE } from './api';

interface IProps {
  setUseSnackbarRef: (showSnackbar: ProviderContext) => void;
}

const InnerSnackbarUtilsConfigurator: React.FC<IProps> = (props: IProps) => {
  props.setUseSnackbarRef(useSnackbar());
  return null;
};

let useSnackbarRef: ProviderContext;
const setUseSnackbarRef = (useSnackbarRefProp: ProviderContext) => {
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsConfigurator = (): JSX.Element => {
  return <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />;
};

export default {
  success(msg?: string, options: OptionsObject = {}): void {
    if (!msg) return;
    setTimeout(() => {
      this.toast(msg, { ...options, variant: 'success' });
    });
  },
  warning(msg?: string, options: OptionsObject = {}): void {
    if (!msg) return;
    setTimeout(() => {
      this.toast(msg, { ...options, variant: 'warning' });
    });
  },
  info(msg?: string, options: OptionsObject = {}): void {
    if (!msg) return;
    setTimeout(() => {
      this.toast(msg, { ...options, variant: 'info' });
    });
  },
  error(msg?: string, options: OptionsObject = {}): void {
    if (!msg || msg === 'Unauthorized' || msg === CANCEL_MESSAGE) {
      return;
    }
    setTimeout(() => {
      this.toast(msg, { ...options, variant: 'error' });
    });
  },
  toast(msg: string, options: OptionsObject = {}): void {
    useSnackbarRef.enqueueSnackbar(msg, { ...options });
  },
  closeSnackbar(key?: SnackbarKey): void {
    useSnackbarRef.closeSnackbar(key);
  },
};
